module.exports = __webpack_public_path__ + "static/media/clipboard.d72eab48.svg";